import React from 'react';
import { Loading } from 'pages/App/components/Loading';
import { useFirestoreCollectionData, SuspenseWithPerf } from 'reactfire';
import { Grid } from 'semantic-ui-react';
import { useHistoryHook } from 'services/hooks/useHistoryHook'
import HistoryItems from '../Items'

function HistoryContentQuestionCore({ questionId, projId, oid }: any) {

  const { collections: { historyByQuestion } } = useHistoryHook(oid);

  const historyData = useFirestoreCollectionData(historyByQuestion(questionId, projId))

  return (
    <>
      <Grid.Row>
        <HistoryItems oid={oid} historyData={historyData} />
      </Grid.Row>
    </>
  );
}

function HistoryContentQuestion(props: any) {
  return (
    <SuspenseWithPerf
      fallback={<Loading />}
      traceId={`howwee-history-${props.oid || ''}-${props.questionId || ''}`}
    >
      <HistoryContentQuestionCore {...props} />
    </SuspenseWithPerf>
  )
}

export default HistoryContentQuestion;